import { FormField, Select, SelectOption } from '@redis-ui/components';
import { FormSelectProps } from './FormSelect.types';
import LabelWithLink from '../LabelWithLink/LabelWithLink';
import * as S from '../FormInput/FormInput.style';

function FormSelect<T = string>({
  className,
  dataTestIdSuffix,
  width,

  textUnderInput,

  label,
  optional,
  required,
  infoIconProps,
  readMore,

  getItemValue,
  onSelectedItemChange,
  renderItem,
  filterFunction,
  searchable,
  placeholder,
  items,
  selectedItem,
  error,
  disabled
}: FormSelectProps<T>) {
  const customCompare =
    filterFunction &&
    ((option: SelectOption, term: string) => filterFunction(option.item as T, term));

  return (
    <S.FormFieldCompose className={className} data-testid={`form-container--${dataTestIdSuffix}`}>
      <LabelWithLink
        label={label}
        optional={optional}
        required={required}
        testId={dataTestIdSuffix}
        readMore={readMore}
        infoIconProps={infoIconProps}
      />
      <FormField.InputContainer style={{ width }}>
        <Select
          disabled={disabled}
          customCompare={customCompare}
          value={getItemValue(selectedItem)}
          onChange={(value) => {
            onSelectedItemChange?.(items.find((item) => getItemValue(item) === value));
          }}
          options={items.map((item) => ({
            item,
            value: getItemValue(item)
          }))}
          error={error}
          data-testid={`selectbox--${dataTestIdSuffix}`}
          valueRender={renderItem ? ({ option }) => renderItem(option.item) : undefined}
          placeholder={placeholder}
          searchable={searchable}
          maxVisibleItems={6}
        />
      </FormField.InputContainer>
      <FormField.AdditionalText>{textUnderInput}</FormField.AdditionalText>
    </S.FormFieldCompose>
  );
}

export default FormSelect;
